module.exports = __webpack_public_path__ + "images/stickers/thumbsup.a16e4077dfa7c7770137.png";